import Phaser from 'phaser'

export class IntroScene extends Phaser.Scene {
  private message?: Phaser.GameObjects.Text

  private hint?: Phaser.GameObjects.Text

  constructor() {
    super('IntroScene')
  }

  create(): void {
    this.message = this.add
      .text(0, 0, 'En el campo de batalla, ¿dónde estará el dispositivo?', {
        fontFamily: 'Segoe UI, system-ui, sans-serif',
        color: '#ffffff',
        align: 'center',
      })
      .setOrigin(0.5, 0.5)

    this.hint = this.add
      .text(0, 0, 'Toque o ENTER para continuar', {
        fontFamily: 'Segoe UI, system-ui, sans-serif',
        color: '#f7b538',
        align: 'center',
      })
      .setOrigin(0.5, 0.5)
      .setInteractive({ useHandCursor: true })

    this.hint.on('pointerdown', () => this.scene.start('GameScene'))

    this.input.keyboard?.once('keydown-ENTER', () => this.scene.start('GameScene'))
    this.input.keyboard?.once('keydown-SPACE', () => this.scene.start('GameScene'))

    this.scale.on('resize', this.handleResize, this)
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
      this.scale.off('resize', this.handleResize, this)
    })

    this.handleResize()
  }

  private handleResize(gameSize?: Phaser.Structs.Size): void {
    const width = gameSize?.width ?? this.scale.width
    const height = gameSize?.height ?? this.scale.height
    const minDimension = Math.min(width, height)

    const textFontSize = Math.max(20, Math.round(minDimension * 0.045))
    const hintFontSize = Math.max(16, Math.round(minDimension * 0.035))
    const wrapWidth = Math.min(width * 0.88, 860)

    this.message?.setFontSize(textFontSize)
    this.message?.setWordWrapWidth(wrapWidth, true)
    this.message?.setPosition(width / 2, height * 0.38)

    this.hint?.setFontSize(hintFontSize)
    this.hint?.setPosition(width / 2, height * 0.63)
  }
}
